import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CampaignMaintenanceComponent } from './campaign-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: CampaignMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CampaignMaintenanceRoutingModule { }
